import type { ErrorTrackerConfig } from '@myhelix/dd-error-tracking';

export const errorTrackerConfig: ErrorTrackerConfig = {
  clientToken: import.meta.env?.VITE_DATADOG_CLIENT_TOKEN,
  applicationId: import.meta.env?.VITE_DATADOG_APPLICATION_ID,
  service: 'partner-experience-fe',
  env: import.meta.env?.MODE,
  // VITE_CIRCLE_SHA1 is only set by CI (see vite.config.ts); local dev has no git-SHA-per-build
  // concept, so fall back to a fixed marker rather than leaving error tracking disabled locally.
  version: import.meta.env?.VITE_CIRCLE_SHA1 || 'local-dev',
  // Explicit rather than relying on @myhelix/dd-error-tracking's own `?? 0` fallback, so we don't
  // silently start recording session replay if that library's default ever changes.
  sessionReplaySampleRate: 0,
  // Rollbar never captured per-click interaction data, only errors — explicitly opting out here
  // until privacy/compliance has reviewed this capability. See PR #1100 review discussion.
  trackUserInteractions: false,
};
